import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Content, P, SectionSubHeading, SectionWrapper } from "../../../styles";

import aboutimage from "../../../images/aboutimage.png";
import mobileabout from "../../../images/mobileabout.png";
import { BASEURL } from "../../../configure";
import Section from "./section";

const Index = () => {
  const [ getSectionData, setSectionData ] = useState('');
  
  let getPrjects = async () => {
    let projects = await fetch(BASEURL+'section?&_embed', {
      method: 'GET',
    })
    const data = await projects.json();
    setSectionData(data.map((val, index) => {
      if (val?.id !== 88 && val?.id !== 93) {
        return  (
          <Section 
            key={index}
            order={index}
            sectionTitle={val?.title?.rendered}
            sectionContent={val?.content?.rendered}
            qoute={val?.metadata?.qout}
            qouteBy={val?.metadata?.qoutBy}
            qouteSign={val?.metadata?.signature}
            sectionImage={val?._embedded?.['wp:featuredmedia'][0]['source_url']}
          />
        )
      }
    }))
  }
  useEffect(()=>{
    getPrjects();
  },[] )
  return (
    <div>
      <SectionWrapper p1230="2rem 0 0" p599="5rem 0" p="0 20px" id="aboutus">
        {getSectionData}
      </SectionWrapper>
    </div>
  );
};

export default Index;
